import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ResetPasswordPage.css";

// 🔧 Base API robuste (prod/dev) : VITE/REACT_APP → nettoyée ; sinon même domaine
const RAW =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  process.env.VITE_API_URL ||
  process.env.REACT_APP_API_URL ||
  "";

const API_BASE =
  RAW
    ? RAW.replace(/\/+$/, "").replace(/\/api$/i, "")
    : (typeof window !== "undefined" && window.location.origin) || "";

function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [msg, setMsg] = useState({ text: "", type: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6 || password.length > 20) {
      setMsg({ text: "Le mot de passe doit contenir entre 6 et 20 caractères.", type: "error" });
      return;
    }
    if (password !== confirm) {
      setMsg({ text: "Les mots de passe ne correspondent pas.", type: "error" });
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/auth/reset_password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setMsg({ text: "✅ Mot de passe modifié ! Vous pouvez vous connecter.", type: "success" });
        setTimeout(() => navigate("/auth/login"), 2000);
      } else {
        setMsg({ text: data?.error || "Erreur.", type: "error" });
      }
    } catch {
      setMsg({ text: "Erreur serveur.", type: "error" });
    }
  };

  return (
    <div className="reset-password-container">
      <h2>Réinitialiser mon mot de passe</h2>
      <form onSubmit={handleSubmit} className="reset-password-form">
        <div style={{ position: "relative", width: "100%" }}>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Nouveau mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", paddingRight: 36 }}
          />
          <span
            className="toggle-password-eye"
            onClick={() => setShowPassword((v) => !v)}
            style={{
              position: "absolute",
              right: 14,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              fontSize: 19,
              color: "#765e47",
            }}
            title={showPassword ? "Masquer" : "Afficher"}
          >
            {showPassword ? "👁️" : "👁️‍🗨️"}
          </span>
        </div>

        <div style={{ position: "relative", width: "100%", marginTop: 12 }}>
          <input
            type={showConfirm ? "text" : "password"}
            placeholder="Confirmer le mot de passe"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            style={{ width: "100%", paddingRight: 36 }}
          />
          <span
            className="toggle-password-eye"
            onClick={() => setShowConfirm((v) => !v)}
            style={{
              position: "absolute",
              right: 14,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              fontSize: 19,
              color: "#765e47",
            }}
            title={showConfirm ? "Masquer" : "Afficher"}
          >
            {showConfirm ? "👁️" : "👁️‍🗨️"}
          </span>
        </div>

        <button type="submit" style={{ marginTop: 18 }}>
          Changer mon mot de passe
        </button>
        {msg.text ? <p className={msg.type}>{msg.text}</p> : null}
      </form>
    </div>
  );
}

export default ResetPasswordPage;

